import { createFileRoute, redirect } from "@tanstack/react-router";
import { isKnownType, typeRedirectUrl } from "@/components/inventory/FilterRedirects";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/new-product/$type")({
  head: () => pageHead({ title: 'Rex & Sons RVs', description: 'Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.', path: '/new-product/:type' }),
  beforeLoad: ({ params }) => {
    const href = isKnownType(params.type)
      ? typeRedirectUrl(params.type, "new")
      : "/rv-search?condition=new";
    throw redirect({ href, statusCode: 301, throw: true });
  },
});
